import React, { useState, useEffect } from 'react'
import './miPerfil.css'
import { MiFooter } from '../../components/footer/MiFooter';
import Header from '../../components/headers/Header';
import { ContentBodyMiPerfil } from '../../components/miPerfil/ContentBodyMiPerfil';
import { ModalesMiPerfil } from '../../components/miPerfil/ModalesMiPerfil';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import ToastNotification from '../../hooks/ToastNotification';

export const MiPerfil = () => {
  const [showToast, setShowToast] = useState(false);

  

  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }

  const [BorrarCuenta, setBorrarCuenta] = useState(false)

  const [GuardarCambios, setGuardarCambios] = useState(false)

  return (
    <div className='miPerfil'  >
      {
        GuardarCambios === true && <div className='modal centrador'>
          <div className='modalGuadarCambios'>
            <div><h3>
              ¿ Estás seguro de guardar tus cambios ?
            </h3></div>
            <div><p>
              Se guardaran los cambios realizados.
            </p></div>
            <div className='buttonsCancelarServicio'>
              <div className='button borrarCuenta'
                onClick={() => setGuardarCambios(false)}>
                Cancelar
              </div>
              <div className='button'>
                Aceptar
              </div>
            </div>
          </div>
        </div>
      }
      {
        BorrarCuenta && <div className='modal centrador '>
          <div className='modalGuadarCambios'>
            <div><h3>
              ¿ Estás seguro de cancelar tus servicios ?
            </h3></div>
            <div><p>
              Pederas toda la información de su cuenta,
              todos los servicios que has contratado se cancelaran
              una vez halla terminado el periodo de facturación actual.
            </p></div>
            <div className='buttonsCancelarServicio'>
              <div className='button borrarCuenta'>
                Cancelar servicio
              </div>
              <div className='button'
                onClick={() => setBorrarCuenta(false)}>
                Seguir
              </div>
            </div>
          </div>
        </div>
      }
      <div className='headerMiPerfil'>
        <Header 
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyMiPerfil">
        <ContentBodyMiPerfil
          setShowToast={setShowToast}
          setBorrarCuenta={setBorrarCuenta}
          setGuardarCambios={setGuardarCambios}
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <ToastNotification
        message="Los cambios se han guardado de forma correcta"
        show={showToast}
        onClose={() => setShowToast(false)}
        type="info"
      />
      <div className='footerReservarServicio'>
        <MiFooter />
      </div>
    </div>
  )
}
